<template>
  <div class="order-list-container">
    <!-- 固定在下拉菜单的占位元素（避免内容被遮挡） -->
    <div class="dropdown-placeholder" v-if="fixedDropdown"></div>

    <van-dropdown-menu class="fixed-dropdown">
      <van-dropdown-item v-model="flag" :options="option1" @change="getMyOrders()" />
      <van-dropdown-item v-model="orderByParam" :options="option2" @change="getMyOrders()" />
    </van-dropdown-menu>

    <!-- 顶部：问候语 + 总数统计（左右分布） -->
    <div class="order-stats">
      <div class="greeting" v-if="customerName">
        尊敬的 <strong>{{ customerName }}</strong
        >，您好！
      </div>
      <div class="greeting" v-else>尊敬的客户，您好！</div>
      <span class="order-count">共计 {{ list.length }} 个委托单</span>
    </div>

    <div v-if="list.length > 0" class="order-list">
      <div v-for="(item, index) in list" :key="index" class="order-card" @click="getOrderDetail(item)">
        <div class="card-index">{{ index + 1 }}</div>

        <!-- 卡片主体：使用 flex 布局，确保箭头始终在最右侧且不换行 -->
        <div class="card-main">
          <div class="card-info">
            <span class="order-id">委托单：{{ item.OrderId }}</span>
            <van-tag :type="getStageType(item.CurStage)" size="medium" class="stage-tag">
              {{ item.CurStage }}
            </van-tag>
            <div v-if="item.Stage === -1" class="received-time">
              <van-icon name="clock-o" size="14" />
              <span>申请日期：{{ item.CreateTime }}</span>
            </div>
            <div v-else class="received-time" :style="{ backgroundColor: getTimeColor(item.SendSampleTime) }">
              <van-icon name="clock-o" size="14" />
              <span>送样日期：{{ item.SendSampleTime }}</span>
            </div>
            <!-- <div class="received-time" :style="{ backgroundColor: getTimeColor(item.ReceivedTime) }">
              <van-icon name="clock-o" size="14" />
              <span>收样日期：{{ item.ReceivedTime }}</span>
            </div> -->
          </div>
          <!-- 箭头图标按钮，独立点击事件，阻止冒泡 -->
          <van-icon name="arrow" class="card-arrow-btn" @click.stop="getOrderDetail(item)" />
        </div>
      </div>
    </div>

    <van-empty v-else description="暂无相关委托单" />

    <!-- 新增：悬浮 + 按钮 -->
    <div class="floating-add-btn" @click="handleAddClick()">
      <van-icon name="plus" size="24" color="#ffffff" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { DropdownMenu, DropdownItem, Empty, Tag } from 'vant'
import axios from 'axios'
import { Toast } from 'vant'

Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Empty)
Vue.use(Tag)

export default {
  data() {
    return {
      fixedDropdown: true,
      flag: 0,
      orderByParam: 2,
      list: [],
      customerName: '', //客户姓名
      code: '',
      openId: '', //微信编号
      // openId: 'oeUrW7eviH_0N6DdCO8VvWAjEGPk', //微信编号
      userId: '', //用户编号
      option1: [{ text: '委托中', value: 0 }, { text: '进行中', value: 1 }, { text: '已完成', value: 2 }],
      option2: [{ text: '收样时间升序', value: 1 }, { text: '收样时间降序', value: 2 }]
    }
  },
  created() {
    this.code = this.getUrlCode()['code']
    this.getMyOrders()
  },
  activated() {
    this.getMyOrders()
  },
  methods: {
    getUrlCode() {
      const url = location.search
      const theRequest = {}
      if (url.indexOf('?') != -1) {
        const str = url.substr(1)
        const strs = str.split('&')
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
        }
      }
      return theRequest
    },
    getMyOrders() {
      const _that = this
      const postLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '查询中...'
      })

      axios
        .post(window.config.apiUrl + '/api/Public/GetMyOrders', {
          Code: _that.code,
          OpenId: _that.openId,
          Flag: _that.flag,
          OrderByParam: _that.orderByParam
        })
        .then(function(response) {
          postLoading.clear()
          const recvData = response.data
          if (recvData.code == 1) {
            _that.list = recvData.data['OrderDetails']
            _that.openId = recvData.data['OpenId']
            _that.customerName = recvData.data['Name']
            _that.userId = recvData.data['UserId']
          } else {
            Toast.fail(recvData.msg)
          }
        })
        .catch(function(error) {
          Toast(error)
          postLoading.clear()
        })
    },
    getOrderDetail(it) {
      if (it.OrderType === 'sysorder') {
        //深海创建的委托单
        this.$router.push('/cart?orderId=' + it.OrderId + '&_t=' + Date.now())
      } else if (it.OrderType === 'customerorder') {
        this.$router.push('/ccOrderDetail?orderId=' + it.Id + '&_t=' + Date.now())
      }
    },
    getStageType(stage) {
      const map = {
        收样: 'warning',
        加工: 'primary',
        试验: 'success',
        报告: 'danger'
      }
      return map[stage] || 'default'
    },
    getTimeColor(timeStr) {
      if (!timeStr) return '#f2f3f5'
      const diffDays = Math.floor((new Date() - new Date(timeStr)) / (1000 * 60 * 60 * 24))
      if (diffDays <= 0) return '#e6f7e6'
      if (diffDays <= 7) return '#fff7e6'
      return '#ffe6e6'
    },
    // 新增：点击悬浮 + 按钮跳转到新页面
    handleAddClick() {
      // 请将 '/your-new-page-route' 替换为你实际配置的路由地址
      this.$router.push('/addOrders?userId=' + this.userId + '&_t=' + Date.now())

      // 如果是弹出一个弹窗，也可以在这里控制弹窗变量
      // this.showPopup = true;
    }
  }
}
</script>

<style scoped>
.fixed-dropdown {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.dropdown-placeholder {
  height: 46px;
}

.card-index {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #5e6ad2, #3f8cff);
  color: white;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.order-card {
  position: relative;
  background: white;
  border-radius: 20px;
  padding: 16px;
  margin-bottom: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.25s;
  cursor: pointer;
  border-left: 5px solid #3f8cff;
}

/* 卡片主要行：使用 flex 布局，不换行，箭头始终在最右侧 */
.card-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-left: 36px;
  flex-wrap: nowrap;
}

/* 左侧信息区域，允许内部换行，但整体不溢出 */
.card-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0; /* 防止溢出 */
}

.order-id {
  font-weight: 600;
  font-size: 15px;
  color: #1f2d3d;
  white-space: nowrap;
}

.stage-tag {
  font-size: 15px;
  padding: 0 8px;
  border-radius: 30px;
  flex-shrink: 0;
}

.received-time {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  flex-shrink: 0;
}

/* 箭头图标按钮样式 */
.card-arrow-btn {
  color: #3f8cff;
  font-size: 16px;
  font-weight: bold;
  padding: 8px;
  background: rgba(63, 140, 255, 0.1);
  border-radius: 50%;
  transition: all 0.2s;
  cursor: pointer;
  flex-shrink: 0;
}
.card-arrow-btn:active {
  transform: scale(0.9);
  background: rgba(63, 140, 255, 0.2);
}

.order-list-container {
  min-height: 100vh;
  background: linear-gradient(145deg, #f0f2f6 0%, #e9ecef 100%);
}
.order-list {
  padding: 12px;
}
.order-card:active {
  transform: scale(0.98);
  background-color: #fafcff;
}

/* 顶部统计栏：左右分布 */
.order-stats {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  margin-top: 12px;
  padding: 0 12px; /* 保持与列表相同的边距 */
}
.greeting {
  font-size: 16px;
  color: #1f2d3d;
}
.greeting strong {
  font-weight: 700;
  color: #3f8cff;
}
.order-count {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  padding: 6px 14px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  color: #3f8cff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

/* 新增：悬浮 + 按钮样式 */
.floating-add-btn {
  position: fixed;
  right: 20px;
  bottom: 40px; /* 距离底部的高度，如底部有导航栏可适当调高 */
  width: 52px;
  height: 52px;
  background-color: #07c160; /* 绿色背景，与截图一致 */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.4);
  z-index: 1001; /* 保证悬浮在所有元素之上 */
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.floating-add-btn:active {
  transform: scale(0.9);
  box-shadow: 0 2px 6px rgba(7, 193, 96, 0.3);
}
</style>
